// extracted by mini-css-extract-plugin
export default {"img":"search_waterbody__img--yEB4","title":"search_waterbody__title--uels","counties":"search_waterbody__counties--b6pt","link":"search_waterbody__link--qMKi"};